
import {
    defineComponent,
    inject,
    isReactive,
    isRef,
    reactive,
    ref,
    toRef,
    watch
} from "vue";
import {
    CigoAdminStore
} from "@/components/cigo-admin-core/store";
import CigoIconFont from "@/components/cigo-ui/unit/basic/cigo-icon-font.vue";
import {
    SystemState
} from "../utils/types";
import {
    showPage
} from "../utils/common";

//TODO 继续优化
export default defineComponent({
    name: "CigoOpenPages",
    components: {
        CigoIconFont
    },
    setup() {
        let menuBaseListNameMapRef: any = inject("menuBaseListNameMapRef");
        let openTabsRef = toRef(CigoAdminStore.getState(), "openTabs");
        let currComponent = toRef(
            CigoAdminStore.getState().systemState,
            "currComponent"
        );

        const makeTabName = (name: string) => {
            if (
                menuBaseListNameMapRef.value &&
                menuBaseListNameMapRef.value.has(name)
            ) {
                let pageItem = menuBaseListNameMapRef.value.get(name);
                return pageItem && pageItem.title ? pageItem.title : name;
            }
            return name;
        };

        const closePage = (name: string) => {
            if (
                menuBaseListNameMapRef.value &&
                menuBaseListNameMapRef.value.has(name)
            ) {
                let pageItem = menuBaseListNameMapRef.value.get(name);
                if (pageItem) {
                    CigoAdminStore.closeOpenTab(
                        name,
                        pageItem,
                        menuBaseListNameMapRef.value
                    );
                }
            }
        };

        const openPage = (name: string) => {
            if (
                menuBaseListNameMapRef.value &&
                menuBaseListNameMapRef.value.has(name)
            ) {
                let pageItem = menuBaseListNameMapRef.value.get(name);
                pageItem ? showPage(pageItem) : false;
            }
        };

        const getDotColor = (name: string) => {
            if (
                menuBaseListNameMapRef.value &&
                menuBaseListNameMapRef.value.has(name)
            ) {
                let pageItem = menuBaseListNameMapRef.value.get(name);
                return pageItem && pageItem.color ? pageItem.color : "#fff";
            }
            return "#fff";
        };

        return {
            currComponent,
            menuBaseListNameMapRef,
            openTabsRef,
            makeTabName,
            closePage,
            openPage,
            getDotColor
        };
    }
});
